import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { ProposalProvider, DisplayProvider, DisplayInfo } from '../types/Components';
import type Action from '../lib/Action';
import type { Proposal } from '../lib/Proposal';
import { ProposalType } from '../lib/Proposal';

/**
 * A component that can block incoming attacks from specific directions.
 */
class Shield extends Component implements ProposalProvider, DisplayProvider {
  bearingOffsets: number[];

  constructor(data: { bearingOffsets?: number[] } = {}) {
    super();
    this.bearingOffsets = data.bearingOffsets ?? [0];
  }

  getDisplayInfo(): DisplayInfo {
    // TODO: dynamically compute the description based on the offsets
    return { icon: 'game-icons:shield', label: 'Shield', description: 'Blocks attacks from the front.' };
  }

  /**
   * Generates a high-priority proposal to augment the action with a block effect.
   */
  getProposedOutcome(_action: Action): Proposal {
    const effect = {
      type: 'BLOCK' as const,
      fromBearings: this.bearingOffsets,
    };

    return {
      type: ProposalType.AUGMENT,
      priority: 0,
      effects: [effect],
    };
  }
}

export default simpleComponent(Shield);
